import { Target, PenTool, TrendingUp } from "lucide-react";
import { useScrollReveal } from "@/hooks/useScrollReveal";

const ICONS = [Target, PenTool, TrendingUp];

export default function Services({ services }) {
  const [ref, isVisible] = useScrollReveal();

  return (
    <section id="hizmetler" className="py-24 md:py-32" data-testid="services-section">
      <div ref={ref} className={`reveal mx-auto max-w-7xl px-6 md:px-12 ${isVisible ? "is-visible" : ""}`}>
        <div className="mx-auto max-w-2xl text-center">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-gold">Hizmetlerimiz</p>
          <h2 className="mt-3 text-2xl font-normal tracking-tight text-white sm:text-3xl lg:text-4xl">
            Uçtan uca Meta reklam yönetimi
          </h2>
          <p className="mt-4 text-base leading-relaxed text-slate-400">
            Instagram reklam ajansı deneyimimizle stratejiden raporlamaya kadar tüm süreci sizin için yönetiyoruz.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-8 md:grid-cols-3">
          {services.map((service, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <div
                key={service.title}
                className="group rounded-2xl border border-white/5 bg-white/[0.02] p-8 shadow-[0_8px_32px_rgba(0,0,0,0.12)] backdrop-blur-xl transition-all duration-300 hover:-translate-y-1 hover:border-gold/30"
                style={{ transitionDelay: isVisible ? `${i * 120}ms` : "0ms" }}
                data-testid={`service-card-${i}`}
              >
                <div className="mb-5 flex h-12 w-12 items-center justify-center rounded-xl border border-gold/20 bg-gold/[0.06] transition-transform duration-300 group-hover:-translate-y-0.5">
                  <Icon className="h-6 w-6 text-gold-light" />
                </div>
                <h3 className="text-xl font-medium text-white sm:text-2xl">{service.title}</h3>
                <p className="mt-3 text-base leading-relaxed text-slate-400">{service.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
